// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgSlugIndexRouteImport } from './routes/$orgSlug/index'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as AcceptInvitationInvitationIdRouteImport } from './routes/accept-invitation.$invitationId'
import { Route as OrgSlugSettingsRouteImport } from './routes/$orgSlug/settings'
import { Route as OrgSlugPeopleRouteImport } from './routes/$orgSlug/people'
import { Route as OrgSlugEventSlugRouteRouteImport } from './routes/$orgSlug/$eventSlug/route'
import { Route as OrgSlugSettingsIndexRouteImport } from './routes/$orgSlug/settings/index'
import { Route as OrgSlugSettingsVaultRouteImport } from './routes/$orgSlug/settings/vault'
import { Route as OrgSlugEventSlugIndexRouteImport } from './routes/$orgSlug/$eventSlug/index'
import { Route as OrgSlugEventSlugYouRouteImport } from './routes/$orgSlug/$eventSlug/you'
import { Route as OrgSlugEventSlugVendorsRouteImport } from './routes/$orgSlug/$eventSlug/vendors'
import { Route as OrgSlugEventSlugTravelRouteImport } from './routes/$orgSlug/$eventSlug/travel'
import { Route as OrgSlugEventSlugTicketsRouteImport } from './routes/$orgSlug/$eventSlug/tickets'
import { Route as OrgSlugEventSlugSettingsRouteImport } from './routes/$orgSlug/$eventSlug/settings'
import { Route as OrgSlugEventSlugScheduleRouteImport } from './routes/$orgSlug/$eventSlug/schedule'
import { Route as OrgSlugEventSlugReportsRouteImport } from './routes/$orgSlug/$eventSlug/reports'
import { Route as OrgSlugEventSlugProfileRouteImport } from './routes/$orgSlug/$eventSlug/profile'
import { Route as OrgSlugEventSlugPeopleRouteImport } from './routes/$orgSlug/$eventSlug/people'
import { Route as OrgSlugEventSlugOrdersRouteImport } from './routes/$orgSlug/$eventSlug/orders'
import { Route as OrgSlugEventSlugLodgingRouteImport } from './routes/$orgSlug/$eventSlug/lodging'
import { Route as OrgSlugEventSlugLocationsRouteImport } from './routes/$orgSlug/$eventSlug/locations'
import { Route as OrgSlugEventSlugLinksRouteImport } from './routes/$orgSlug/$eventSlug/links'
import { Route as OrgSlugEventSlugFormsRouteImport } from './routes/$orgSlug/$eventSlug/forms'
import { Route as OrgSlugEventSlugEmergencyContactsRouteImport } from './routes/$orgSlug/$eventSlug/emergency-contacts'
import { Route as OrgSlugEventSlugDocumentsRouteImport } from './routes/$orgSlug/$eventSlug/documents'
import { Route as OrgSlugEventSlugDietaryRouteImport } from './routes/$orgSlug/$eventSlug/dietary'
import { Route as OrgSlugEventSlugConversationsRouteImport } from './routes/$orgSlug/$eventSlug/conversations'
import { Route as OrgSlugEventSlugChannelsRouteImport } from './routes/$orgSlug/$eventSlug/channels'
import { Route as OrgSlugEventSlugBadgesRouteImport } from './routes/$orgSlug/$eventSlug/badges'
import { Route as OrgSlugEventSlugBadgeDesignRouteImport } from './routes/$orgSlug/$eventSlug/badge-design'
import { Route as OrgSlugEventSlugActivityRouteImport } from './routes/$orgSlug/$eventSlug/activity'
import { Route as OrgSlugEventSlugAccommodationsRouteImport } from './routes/$orgSlug/$eventSlug/accommodations'
import { Route as OrgSlugEventSlugTTicketIdRouteImport } from './routes/$orgSlug/$eventSlug/t/$ticketId'
import { Route as OrgSlugEventSlugStayBookingIdRouteImport } from './routes/$orgSlug/$eventSlug/stay/$bookingId'
import { Route as OrgSlugEventSlugSessionAgendaItemIdRouteImport } from './routes/$orgSlug/$eventSlug/session.$agendaItemId'
import { Route as OrgSlugEventSlugPersonGuestIdRouteImport } from './routes/$orgSlug/$eventSlug/person/$guestId'
import { Route as OrgSlugEventSlugPPageIdRouteImport } from './routes/$orgSlug/$eventSlug/p/$pageId'
import { Route as OrgSlugEventSlugMSegmentIdRouteImport } from './routes/$orgSlug/$eventSlug/m/$segmentId'
import { Route as OrgSlugEventSlugFFormIdRouteImport } from './routes/$orgSlug/$eventSlug/f/$formId'
import { Route as OrgSlugEventSlugDocDocumentIdRouteImport } from './routes/$orgSlug/$eventSlug/doc/$documentId'
import { Route as OrgSlugEventSlugDConversationIdRouteImport } from './routes/$orgSlug/$eventSlug/d/$conversationId'
import { Route as OrgSlugEventSlugCChannelIdRouteImport } from './routes/$orgSlug/$eventSlug/c/$channelId'
import { Route as OrgSlugEventSlugVendorsVendorIdRouteImport } from './routes/$orgSlug/$eventSlug/vendors/$vendorId'
import { Route as OrgSlugEventSlugTravelSegmentIdRouteImport } from './routes/$orgSlug/$eventSlug/travel/$segmentId'
import { Route as OrgSlugEventSlugTicketsTicketIdRouteImport } from './routes/$orgSlug/$eventSlug/tickets/$ticketId'
import { Route as OrgSlugEventSlugSettingsIndexRouteImport } from './routes/$orgSlug/$eventSlug/settings/index'
import { Route as OrgSlugEventSlugSettingsTicketingRouteImport } from './routes/$orgSlug/$eventSlug/settings/ticketing'
import { Route as OrgSlugEventSlugSettingsSiteRouteImport } from './routes/$orgSlug/$eventSlug/settings/site'
import { Route as OrgSlugEventSlugSettingsRemindersRouteImport } from './routes/$orgSlug/$eventSlug/settings/reminders'
import { Route as OrgSlugEventSlugSettingsRegistrationRouteImport } from './routes/$orgSlug/$eventSlug/settings/registration'
import { Route as OrgSlugEventSlugSettingsPermissionsRouteImport } from './routes/$orgSlug/$eventSlug/settings/permissions'
import { Route as OrgSlugEventSlugSettingsInvitesRouteImport } from './routes/$orgSlug/$eventSlug/settings/invites'
import { Route as OrgSlugEventSlugSettingsIntegrationsRouteImport } from './routes/$orgSlug/$eventSlug/settings/integrations'
import { Route as OrgSlugEventSlugSettingsFeatureFlagsRouteImport } from './routes/$orgSlug/$eventSlug/settings/feature-flags'
import { Route as OrgSlugEventSlugSettingsDetailsRouteImport } from './routes/$orgSlug/$eventSlug/settings/details'
import { Route as OrgSlugEventSlugSettingsBrandingRouteImport } from './routes/$orgSlug/$eventSlug/settings/branding'
import { Route as OrgSlugEventSlugSettingsAttendeeDataRouteImport } from './routes/$orgSlug/$eventSlug/settings/attendee-data'
import { Route as OrgSlugEventSlugScheduleAgendaItemIdRouteImport } from './routes/$orgSlug/$eventSlug/schedule/$agendaItemId'
import { Route as OrgSlugEventSlugPeopleGuestIdRouteImport } from './routes/$orgSlug/$eventSlug/people/$guestId'
import { Route as OrgSlugEventSlugLodgingBookingIdRouteImport } from './routes/$orgSlug/$eventSlug/lodging/$bookingId'
import { Route as OrgSlugEventSlugLocationsLocationIdRouteImport } from './routes/$orgSlug/$eventSlug/locations/$locationId'
import { Route as OrgSlugEventSlugFormsFormIdRouteImport } from './routes/$orgSlug/$eventSlug/forms/$formId'
import { Route as OrgSlugEventSlugConversationsConversationIdRouteImport } from './routes/$orgSlug/$eventSlug/conversations/$conversationId'
import { Route as OrgSlugEventSlugChannelsInternalRouteImport } from './routes/$orgSlug/$eventSlug/channels/internal'
import { Route as OrgSlugEventSlugChannelsGuestRouteImport } from './routes/$orgSlug/$eventSlug/channels/guest'
import { Route as OrgSlugEventSlugChannelsChannelIdRouteImport } from './routes/$orgSlug/$eventSlug/channels/$channelId'
import { Route as OrgSlugEventSlugFormsFormIdResponseIdRouteImport } from './routes/$orgSlug/$eventSlug/forms/$formId/$responseId'
import { Route as OrgSlugEventSlugChannelsInternalChannelIdRouteImport } from './routes/$orgSlug/$eventSlug/channels/internal/$channelId'
import { Route as OrgSlugEventSlugChannelsGuestChannelIdRouteImport } from './routes/$orgSlug/$eventSlug/channels/guest/$channelId'
import { Route as OrgSlugEventSlugConversationsConversationIdThreadThreadIdRouteImport } from './routes/$orgSlug/$eventSlug/conversations/$conversationId/thread/$threadId'
import { Route as OrgSlugEventSlugChannelsInternalChannelIdSettingsRouteImport } from './routes/$orgSlug/$eventSlug/channels/internal/$channelId/settings'
import { Route as OrgSlugEventSlugChannelsGuestChannelIdSettingsRouteImport } from './routes/$orgSlug/$eventSlug/channels/guest/$channelId/settings'
import { Route as OrgSlugEventSlugChannelsInternalChannelIdThreadThreadIdRouteImport } from './routes/$orgSlug/$eventSlug/channels/internal/$channelId/thread/$threadId'
import { Route as OrgSlugEventSlugChannelsGuestChannelIdThreadThreadIdRouteImport } from './routes/$orgSlug/$eventSlug/channels/guest/$channelId/thread/$threadId'

const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SetPasswordRoute = SetPasswordRouteImport.update({
            id: '/set-password',path: '/set-password',getParentRoute: () => rootRouteImport
          })
const PlatformRoute = PlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const OrgSlugIndexRoute = OrgSlugIndexRouteImport.update({
            id: '/$orgSlug/',path: '/$orgSlug/',getParentRoute: () => rootRouteImport
          })
const OauthConsentRoute = OauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AcceptInvitationInvitationIdRoute = AcceptInvitationInvitationIdRouteImport.update({
            id: '/accept-invitation/$invitationId',path: '/accept-invitation/$invitationId',getParentRoute: () => rootRouteImport
          })
const OrgSlugSettingsRoute = OrgSlugSettingsRouteImport.update({
            id: '/$orgSlug/settings',path: '/$orgSlug/settings',getParentRoute: () => rootRouteImport
          })
const OrgSlugPeopleRoute = OrgSlugPeopleRouteImport.update({
            id: '/$orgSlug/people',path: '/$orgSlug/people',getParentRoute: () => rootRouteImport
          })
const OrgSlugEventSlugRouteRoute = OrgSlugEventSlugRouteRouteImport.update({
            id: '/$orgSlug/$eventSlug',path: '/$orgSlug/$eventSlug',getParentRoute: () => rootRouteImport
          })
const OrgSlugSettingsIndexRoute = OrgSlugSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrgSlugSettingsRoute
          })
const OrgSlugSettingsVaultRoute = OrgSlugSettingsVaultRouteImport.update({
            id: '/vault',path: '/vault',getParentRoute: () => OrgSlugSettingsRoute
          })
const OrgSlugEventSlugIndexRoute = OrgSlugEventSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugYouRoute = OrgSlugEventSlugYouRouteImport.update({
            id: '/you',path: '/you',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugVendorsRoute = OrgSlugEventSlugVendorsRouteImport.update({
            id: '/vendors',path: '/vendors',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugTravelRoute = OrgSlugEventSlugTravelRouteImport.update({
            id: '/travel',path: '/travel',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugTicketsRoute = OrgSlugEventSlugTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugSettingsRoute = OrgSlugEventSlugSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugScheduleRoute = OrgSlugEventSlugScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugReportsRoute = OrgSlugEventSlugReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugProfileRoute = OrgSlugEventSlugProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugPeopleRoute = OrgSlugEventSlugPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugOrdersRoute = OrgSlugEventSlugOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugLodgingRoute = OrgSlugEventSlugLodgingRouteImport.update({
            id: '/lodging',path: '/lodging',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugLocationsRoute = OrgSlugEventSlugLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugLinksRoute = OrgSlugEventSlugLinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugFormsRoute = OrgSlugEventSlugFormsRouteImport.update({
            id: '/forms',path: '/forms',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugEmergencyContactsRoute = OrgSlugEventSlugEmergencyContactsRouteImport.update({
            id: '/emergency-contacts',path: '/emergency-contacts',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugDocumentsRoute = OrgSlugEventSlugDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugDietaryRoute = OrgSlugEventSlugDietaryRouteImport.update({
            id: '/dietary',path: '/dietary',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugConversationsRoute = OrgSlugEventSlugConversationsRouteImport.update({
            id: '/conversations',path: '/conversations',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugChannelsRoute = OrgSlugEventSlugChannelsRouteImport.update({
            id: '/channels',path: '/channels',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugBadgesRoute = OrgSlugEventSlugBadgesRouteImport.update({
            id: '/badges',path: '/badges',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugBadgeDesignRoute = OrgSlugEventSlugBadgeDesignRouteImport.update({
            id: '/badge-design',path: '/badge-design',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugActivityRoute = OrgSlugEventSlugActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugAccommodationsRoute = OrgSlugEventSlugAccommodationsRouteImport.update({
            id: '/accommodations',path: '/accommodations',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugTTicketIdRoute = OrgSlugEventSlugTTicketIdRouteImport.update({
            id: '/t/$ticketId',path: '/t/$ticketId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugStayBookingIdRoute = OrgSlugEventSlugStayBookingIdRouteImport.update({
            id: '/stay/$bookingId',path: '/stay/$bookingId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugSessionAgendaItemIdRoute = OrgSlugEventSlugSessionAgendaItemIdRouteImport.update({
            id: '/session/$agendaItemId',path: '/session/$agendaItemId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugPersonGuestIdRoute = OrgSlugEventSlugPersonGuestIdRouteImport.update({
            id: '/person/$guestId',path: '/person/$guestId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugPPageIdRoute = OrgSlugEventSlugPPageIdRouteImport.update({
            id: '/p/$pageId',path: '/p/$pageId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugMSegmentIdRoute = OrgSlugEventSlugMSegmentIdRouteImport.update({
            id: '/m/$segmentId',path: '/m/$segmentId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugFFormIdRoute = OrgSlugEventSlugFFormIdRouteImport.update({
            id: '/f/$formId',path: '/f/$formId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugDocDocumentIdRoute = OrgSlugEventSlugDocDocumentIdRouteImport.update({
            id: '/doc/$documentId',path: '/doc/$documentId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugDConversationIdRoute = OrgSlugEventSlugDConversationIdRouteImport.update({
            id: '/d/$conversationId',path: '/d/$conversationId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugCChannelIdRoute = OrgSlugEventSlugCChannelIdRouteImport.update({
            id: '/c/$channelId',path: '/c/$channelId',getParentRoute: () => OrgSlugEventSlugRouteRoute
          })
const OrgSlugEventSlugVendorsVendorIdRoute = OrgSlugEventSlugVendorsVendorIdRouteImport.update({
            id: '/$vendorId',path: '/$vendorId',getParentRoute: () => OrgSlugEventSlugVendorsRoute
          })
const OrgSlugEventSlugTravelSegmentIdRoute = OrgSlugEventSlugTravelSegmentIdRouteImport.update({
            id: '/$segmentId',path: '/$segmentId',getParentRoute: () => OrgSlugEventSlugTravelRoute
          })
const OrgSlugEventSlugTicketsTicketIdRoute = OrgSlugEventSlugTicketsTicketIdRouteImport.update({
            id: '/$ticketId',path: '/$ticketId',getParentRoute: () => OrgSlugEventSlugTicketsRoute
          })
const OrgSlugEventSlugSettingsIndexRoute = OrgSlugEventSlugSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsTicketingRoute = OrgSlugEventSlugSettingsTicketingRouteImport.update({
            id: '/ticketing',path: '/ticketing',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsSiteRoute = OrgSlugEventSlugSettingsSiteRouteImport.update({
            id: '/site',path: '/site',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsRemindersRoute = OrgSlugEventSlugSettingsRemindersRouteImport.update({
            id: '/reminders',path: '/reminders',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsRegistrationRoute = OrgSlugEventSlugSettingsRegistrationRouteImport.update({
            id: '/registration',path: '/registration',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsPermissionsRoute = OrgSlugEventSlugSettingsPermissionsRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsInvitesRoute = OrgSlugEventSlugSettingsInvitesRouteImport.update({
            id: '/invites',path: '/invites',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsIntegrationsRoute = OrgSlugEventSlugSettingsIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsFeatureFlagsRoute = OrgSlugEventSlugSettingsFeatureFlagsRouteImport.update({
            id: '/feature-flags',path: '/feature-flags',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsDetailsRoute = OrgSlugEventSlugSettingsDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsBrandingRoute = OrgSlugEventSlugSettingsBrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugSettingsAttendeeDataRoute = OrgSlugEventSlugSettingsAttendeeDataRouteImport.update({
            id: '/attendee-data',path: '/attendee-data',getParentRoute: () => OrgSlugEventSlugSettingsRoute
          })
const OrgSlugEventSlugScheduleAgendaItemIdRoute = OrgSlugEventSlugScheduleAgendaItemIdRouteImport.update({
            id: '/$agendaItemId',path: '/$agendaItemId',getParentRoute: () => OrgSlugEventSlugScheduleRoute
          })
const OrgSlugEventSlugPeopleGuestIdRoute = OrgSlugEventSlugPeopleGuestIdRouteImport.update({
            id: '/$guestId',path: '/$guestId',getParentRoute: () => OrgSlugEventSlugPeopleRoute
          })
const OrgSlugEventSlugLodgingBookingIdRoute = OrgSlugEventSlugLodgingBookingIdRouteImport.update({
            id: '/$bookingId',path: '/$bookingId',getParentRoute: () => OrgSlugEventSlugLodgingRoute
          })
const OrgSlugEventSlugLocationsLocationIdRoute = OrgSlugEventSlugLocationsLocationIdRouteImport.update({
            id: '/$locationId',path: '/$locationId',getParentRoute: () => OrgSlugEventSlugLocationsRoute
          })
const OrgSlugEventSlugFormsFormIdRoute = OrgSlugEventSlugFormsFormIdRouteImport.update({
            id: '/$formId',path: '/$formId',getParentRoute: () => OrgSlugEventSlugFormsRoute
          })
const OrgSlugEventSlugConversationsConversationIdRoute = OrgSlugEventSlugConversationsConversationIdRouteImport.update({
            id: '/$conversationId',path: '/$conversationId',getParentRoute: () => OrgSlugEventSlugConversationsRoute
          })
const OrgSlugEventSlugChannelsInternalRoute = OrgSlugEventSlugChannelsInternalRouteImport.update({
            id: '/internal',path: '/internal',getParentRoute: () => OrgSlugEventSlugChannelsRoute
          })
const OrgSlugEventSlugChannelsGuestRoute = OrgSlugEventSlugChannelsGuestRouteImport.update({
            id: '/guest',path: '/guest',getParentRoute: () => OrgSlugEventSlugChannelsRoute
          })
const OrgSlugEventSlugChannelsChannelIdRoute = OrgSlugEventSlugChannelsChannelIdRouteImport.update({
            id: '/$channelId',path: '/$channelId',getParentRoute: () => OrgSlugEventSlugChannelsRoute
          })
const OrgSlugEventSlugFormsFormIdResponseIdRoute = OrgSlugEventSlugFormsFormIdResponseIdRouteImport.update({
            id: '/$responseId',path: '/$responseId',getParentRoute: () => OrgSlugEventSlugFormsFormIdRoute
          })
const OrgSlugEventSlugChannelsInternalChannelIdRoute = OrgSlugEventSlugChannelsInternalChannelIdRouteImport.update({
            id: '/$channelId',path: '/$channelId',getParentRoute: () => OrgSlugEventSlugChannelsInternalRoute
          })
const OrgSlugEventSlugChannelsGuestChannelIdRoute = OrgSlugEventSlugChannelsGuestChannelIdRouteImport.update({
            id: '/$channelId',path: '/$channelId',getParentRoute: () => OrgSlugEventSlugChannelsGuestRoute
          })
const OrgSlugEventSlugConversationsConversationIdThreadThreadIdRoute = OrgSlugEventSlugConversationsConversationIdThreadThreadIdRouteImport.update({
            id: '/thread/$threadId',path: '/thread/$threadId',getParentRoute: () => OrgSlugEventSlugConversationsConversationIdRoute
          })
const OrgSlugEventSlugChannelsInternalChannelIdSettingsRoute = OrgSlugEventSlugChannelsInternalChannelIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => OrgSlugEventSlugChannelsInternalChannelIdRoute
          })
const OrgSlugEventSlugChannelsGuestChannelIdSettingsRoute = OrgSlugEventSlugChannelsGuestChannelIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => OrgSlugEventSlugChannelsGuestChannelIdRoute
          })
const OrgSlugEventSlugChannelsInternalChannelIdThreadThreadIdRoute = OrgSlugEventSlugChannelsInternalChannelIdThreadThreadIdRouteImport.update({
            id: '/thread/$threadId',path: '/thread/$threadId',getParentRoute: () => OrgSlugEventSlugChannelsInternalChannelIdRoute
          })
const OrgSlugEventSlugChannelsGuestChannelIdThreadThreadIdRoute = OrgSlugEventSlugChannelsGuestChannelIdThreadThreadIdRouteImport.update({
            id: '/thread/$threadId',path: '/thread/$threadId',getParentRoute: () => OrgSlugEventSlugChannelsGuestChannelIdRoute
          })





const OrgSlugEventSlugChannelsGuestChannelIdRouteChildren = {
  OrgSlugEventSlugChannelsGuestChannelIdSettingsRoute: OrgSlugEventSlugChannelsGuestChannelIdSettingsRoute,OrgSlugEventSlugChannelsGuestChannelIdThreadThreadIdRoute: OrgSlugEventSlugChannelsGuestChannelIdThreadThreadIdRoute
}

const OrgSlugEventSlugChannelsGuestChannelIdRouteWithChildren = OrgSlugEventSlugChannelsGuestChannelIdRoute._addFileChildren(OrgSlugEventSlugChannelsGuestChannelIdRouteChildren)



const OrgSlugEventSlugChannelsGuestRouteChildren = {
  OrgSlugEventSlugChannelsGuestChannelIdRoute: OrgSlugEventSlugChannelsGuestChannelIdRouteWithChildren
}

const OrgSlugEventSlugChannelsGuestRouteWithChildren = OrgSlugEventSlugChannelsGuestRoute._addFileChildren(OrgSlugEventSlugChannelsGuestRouteChildren)




const OrgSlugEventSlugChannelsInternalChannelIdRouteChildren = {
  OrgSlugEventSlugChannelsInternalChannelIdSettingsRoute: OrgSlugEventSlugChannelsInternalChannelIdSettingsRoute,OrgSlugEventSlugChannelsInternalChannelIdThreadThreadIdRoute: OrgSlugEventSlugChannelsInternalChannelIdThreadThreadIdRoute
}

const OrgSlugEventSlugChannelsInternalChannelIdRouteWithChildren = OrgSlugEventSlugChannelsInternalChannelIdRoute._addFileChildren(OrgSlugEventSlugChannelsInternalChannelIdRouteChildren)



const OrgSlugEventSlugChannelsInternalRouteChildren = {
  OrgSlugEventSlugChannelsInternalChannelIdRoute: OrgSlugEventSlugChannelsInternalChannelIdRouteWithChildren
}

const OrgSlugEventSlugChannelsInternalRouteWithChildren = OrgSlugEventSlugChannelsInternalRoute._addFileChildren(OrgSlugEventSlugChannelsInternalRouteChildren)



const OrgSlugEventSlugChannelsRouteChildren = {
  OrgSlugEventSlugChannelsChannelIdRoute: OrgSlugEventSlugChannelsChannelIdRoute,OrgSlugEventSlugChannelsGuestRoute: OrgSlugEventSlugChannelsGuestRouteWithChildren,OrgSlugEventSlugChannelsInternalRoute: OrgSlugEventSlugChannelsInternalRouteWithChildren
}

const OrgSlugEventSlugChannelsRouteWithChildren = OrgSlugEventSlugChannelsRoute._addFileChildren(OrgSlugEventSlugChannelsRouteChildren)




const OrgSlugEventSlugConversationsConversationIdRouteChildren = {
  OrgSlugEventSlugConversationsConversationIdThreadThreadIdRoute: OrgSlugEventSlugConversationsConversationIdThreadThreadIdRoute
}

const OrgSlugEventSlugConversationsConversationIdRouteWithChildren = OrgSlugEventSlugConversationsConversationIdRoute._addFileChildren(OrgSlugEventSlugConversationsConversationIdRouteChildren)



const OrgSlugEventSlugConversationsRouteChildren = {
  OrgSlugEventSlugConversationsConversationIdRoute: OrgSlugEventSlugConversationsConversationIdRouteWithChildren
}

const OrgSlugEventSlugConversationsRouteWithChildren = OrgSlugEventSlugConversationsRoute._addFileChildren(OrgSlugEventSlugConversationsRouteChildren)




const OrgSlugEventSlugFormsFormIdRouteChildren = {
  OrgSlugEventSlugFormsFormIdResponseIdRoute: OrgSlugEventSlugFormsFormIdResponseIdRoute
}

const OrgSlugEventSlugFormsFormIdRouteWithChildren = OrgSlugEventSlugFormsFormIdRoute._addFileChildren(OrgSlugEventSlugFormsFormIdRouteChildren)



const OrgSlugEventSlugFormsRouteChildren = {
  OrgSlugEventSlugFormsFormIdRoute: OrgSlugEventSlugFormsFormIdRouteWithChildren
}

const OrgSlugEventSlugFormsRouteWithChildren = OrgSlugEventSlugFormsRoute._addFileChildren(OrgSlugEventSlugFormsRouteChildren)




const OrgSlugEventSlugLocationsRouteChildren = {
  OrgSlugEventSlugLocationsLocationIdRoute: OrgSlugEventSlugLocationsLocationIdRoute
}

const OrgSlugEventSlugLocationsRouteWithChildren = OrgSlugEventSlugLocationsRoute._addFileChildren(OrgSlugEventSlugLocationsRouteChildren)




const OrgSlugEventSlugLodgingRouteChildren = {
  OrgSlugEventSlugLodgingBookingIdRoute: OrgSlugEventSlugLodgingBookingIdRoute
}

const OrgSlugEventSlugLodgingRouteWithChildren = OrgSlugEventSlugLodgingRoute._addFileChildren(OrgSlugEventSlugLodgingRouteChildren)




const OrgSlugEventSlugPeopleRouteChildren = {
  OrgSlugEventSlugPeopleGuestIdRoute: OrgSlugEventSlugPeopleGuestIdRoute
}

const OrgSlugEventSlugPeopleRouteWithChildren = OrgSlugEventSlugPeopleRoute._addFileChildren(OrgSlugEventSlugPeopleRouteChildren)




const OrgSlugEventSlugScheduleRouteChildren = {
  OrgSlugEventSlugScheduleAgendaItemIdRoute: OrgSlugEventSlugScheduleAgendaItemIdRoute
}

const OrgSlugEventSlugScheduleRouteWithChildren = OrgSlugEventSlugScheduleRoute._addFileChildren(OrgSlugEventSlugScheduleRouteChildren)




const OrgSlugEventSlugSettingsRouteChildren = {
  OrgSlugEventSlugSettingsAttendeeDataRoute: OrgSlugEventSlugSettingsAttendeeDataRoute,OrgSlugEventSlugSettingsBrandingRoute: OrgSlugEventSlugSettingsBrandingRoute,OrgSlugEventSlugSettingsDetailsRoute: OrgSlugEventSlugSettingsDetailsRoute,OrgSlugEventSlugSettingsFeatureFlagsRoute: OrgSlugEventSlugSettingsFeatureFlagsRoute,OrgSlugEventSlugSettingsIntegrationsRoute: OrgSlugEventSlugSettingsIntegrationsRoute,OrgSlugEventSlugSettingsInvitesRoute: OrgSlugEventSlugSettingsInvitesRoute,OrgSlugEventSlugSettingsPermissionsRoute: OrgSlugEventSlugSettingsPermissionsRoute,OrgSlugEventSlugSettingsRegistrationRoute: OrgSlugEventSlugSettingsRegistrationRoute,OrgSlugEventSlugSettingsRemindersRoute: OrgSlugEventSlugSettingsRemindersRoute,OrgSlugEventSlugSettingsSiteRoute: OrgSlugEventSlugSettingsSiteRoute,OrgSlugEventSlugSettingsTicketingRoute: OrgSlugEventSlugSettingsTicketingRoute,OrgSlugEventSlugSettingsIndexRoute: OrgSlugEventSlugSettingsIndexRoute
}

const OrgSlugEventSlugSettingsRouteWithChildren = OrgSlugEventSlugSettingsRoute._addFileChildren(OrgSlugEventSlugSettingsRouteChildren)




const OrgSlugEventSlugTicketsRouteChildren = {
  OrgSlugEventSlugTicketsTicketIdRoute: OrgSlugEventSlugTicketsTicketIdRoute
}

const OrgSlugEventSlugTicketsRouteWithChildren = OrgSlugEventSlugTicketsRoute._addFileChildren(OrgSlugEventSlugTicketsRouteChildren)




const OrgSlugEventSlugTravelRouteChildren = {
  OrgSlugEventSlugTravelSegmentIdRoute: OrgSlugEventSlugTravelSegmentIdRoute
}

const OrgSlugEventSlugTravelRouteWithChildren = OrgSlugEventSlugTravelRoute._addFileChildren(OrgSlugEventSlugTravelRouteChildren)




const OrgSlugEventSlugVendorsRouteChildren = {
  OrgSlugEventSlugVendorsVendorIdRoute: OrgSlugEventSlugVendorsVendorIdRoute
}

const OrgSlugEventSlugVendorsRouteWithChildren = OrgSlugEventSlugVendorsRoute._addFileChildren(OrgSlugEventSlugVendorsRouteChildren)



const OrgSlugEventSlugRouteRouteChildren = {
  OrgSlugEventSlugAccommodationsRoute: OrgSlugEventSlugAccommodationsRoute,OrgSlugEventSlugActivityRoute: OrgSlugEventSlugActivityRoute,OrgSlugEventSlugBadgeDesignRoute: OrgSlugEventSlugBadgeDesignRoute,OrgSlugEventSlugBadgesRoute: OrgSlugEventSlugBadgesRoute,OrgSlugEventSlugChannelsRoute: OrgSlugEventSlugChannelsRouteWithChildren,OrgSlugEventSlugConversationsRoute: OrgSlugEventSlugConversationsRouteWithChildren,OrgSlugEventSlugDietaryRoute: OrgSlugEventSlugDietaryRoute,OrgSlugEventSlugDocumentsRoute: OrgSlugEventSlugDocumentsRoute,OrgSlugEventSlugEmergencyContactsRoute: OrgSlugEventSlugEmergencyContactsRoute,OrgSlugEventSlugFormsRoute: OrgSlugEventSlugFormsRouteWithChildren,OrgSlugEventSlugLinksRoute: OrgSlugEventSlugLinksRoute,OrgSlugEventSlugLocationsRoute: OrgSlugEventSlugLocationsRouteWithChildren,OrgSlugEventSlugLodgingRoute: OrgSlugEventSlugLodgingRouteWithChildren,OrgSlugEventSlugOrdersRoute: OrgSlugEventSlugOrdersRoute,OrgSlugEventSlugPeopleRoute: OrgSlugEventSlugPeopleRouteWithChildren,OrgSlugEventSlugProfileRoute: OrgSlugEventSlugProfileRoute,OrgSlugEventSlugReportsRoute: OrgSlugEventSlugReportsRoute,OrgSlugEventSlugScheduleRoute: OrgSlugEventSlugScheduleRouteWithChildren,OrgSlugEventSlugSettingsRoute: OrgSlugEventSlugSettingsRouteWithChildren,OrgSlugEventSlugTicketsRoute: OrgSlugEventSlugTicketsRouteWithChildren,OrgSlugEventSlugTravelRoute: OrgSlugEventSlugTravelRouteWithChildren,OrgSlugEventSlugVendorsRoute: OrgSlugEventSlugVendorsRouteWithChildren,OrgSlugEventSlugYouRoute: OrgSlugEventSlugYouRoute,OrgSlugEventSlugIndexRoute: OrgSlugEventSlugIndexRoute,OrgSlugEventSlugCChannelIdRoute: OrgSlugEventSlugCChannelIdRoute,OrgSlugEventSlugDConversationIdRoute: OrgSlugEventSlugDConversationIdRoute,OrgSlugEventSlugDocDocumentIdRoute: OrgSlugEventSlugDocDocumentIdRoute,OrgSlugEventSlugFFormIdRoute: OrgSlugEventSlugFFormIdRoute,OrgSlugEventSlugMSegmentIdRoute: OrgSlugEventSlugMSegmentIdRoute,OrgSlugEventSlugPPageIdRoute: OrgSlugEventSlugPPageIdRoute,OrgSlugEventSlugPersonGuestIdRoute: OrgSlugEventSlugPersonGuestIdRoute,OrgSlugEventSlugSessionAgendaItemIdRoute: OrgSlugEventSlugSessionAgendaItemIdRoute,OrgSlugEventSlugStayBookingIdRoute: OrgSlugEventSlugStayBookingIdRoute,OrgSlugEventSlugTTicketIdRoute: OrgSlugEventSlugTTicketIdRoute
}

const OrgSlugEventSlugRouteRouteWithChildren = OrgSlugEventSlugRouteRoute._addFileChildren(OrgSlugEventSlugRouteRouteChildren)




const OrgSlugSettingsRouteChildren = {
  OrgSlugSettingsVaultRoute: OrgSlugSettingsVaultRoute,OrgSlugSettingsIndexRoute: OrgSlugSettingsIndexRoute
}

const OrgSlugSettingsRouteWithChildren = OrgSlugSettingsRoute._addFileChildren(OrgSlugSettingsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PlatformRoute: PlatformRoute,SetPasswordRoute: SetPasswordRoute,SignInRoute: SignInRoute,OrgSlugEventSlugRouteRoute: OrgSlugEventSlugRouteRouteWithChildren,OrgSlugPeopleRoute: OrgSlugPeopleRoute,OrgSlugSettingsRoute: OrgSlugSettingsRouteWithChildren,AcceptInvitationInvitationIdRoute: AcceptInvitationInvitationIdRoute,OauthConsentRoute: OauthConsentRoute,OrgSlugIndexRoute: OrgSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)